import { memo } from 'react'

const Component = (props) => {
    const { child } = props

    return child
}

export default memo(Component , (prevState, nextState) => prevState.dummy === nextState.dummy)